import { useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { LoadingPlaceHolder } from '../LoadingPlaceholder';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceWrapper = ({
  columnConfig
}) => {
  const {
    displayOptions
  } = useFeatureTableSessionCache();
  const shouldHidePrice = useMemo(() => {
    var _columnConfig$price, _columnConfig$price2, _columnConfig$price3;
    if ((displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.showPrice) === false) {
      return true;
    }
    if (columnConfig.price === undefined) {
      return true;
    }
    if (isNaN((_columnConfig$price = columnConfig.price) === null || _columnConfig$price === void 0 ? void 0 : _columnConfig$price.price)) {
      return true;
    }
    return Boolean(columnConfig.productApiName.includes('free') || ((_columnConfig$price2 = columnConfig.price) === null || _columnConfig$price2 === void 0 ? void 0 : _columnConfig$price2.price) === null || ((_columnConfig$price3 = columnConfig.price) === null || _columnConfig$price3 === void 0 ? void 0 : _columnConfig$price3.price) === 0);
  }, [columnConfig.productApiName, columnConfig.price, displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.showPrice]);
  return /*#__PURE__*/_jsx(View, {
    blockSize: "30px",
    marginBlockEnd: "300",
    children: shouldHidePrice ? null : columnConfig.price === undefined ? /*#__PURE__*/_jsx(LoadingPlaceHolder, {
      width: 220,
      height: 30
    }) : /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: columnConfig.price.price,
        showPricePerMonthPerSeat: columnConfig.showPricePerMonthPerSeat,
        seleniumId: `feature-table-price-${columnConfig.productApiName}`,
        currencyCode: columnConfig.price.currencyCode
      })
    })
  });
};